module.exports = __webpack_public_path__ + "img/axle_conf_7.a3e73b0f.jpg";